/**
 * Zod input schemas: usl. Split out of the one big schemas.ts (Oct 2026) so a session opens only the tool it
 * works on; nothing changed in the schemas themselves. Import as before, from '@daaily/shared' (or './schemas.js'
 * inside shared); the barrel re-exports every file in this folder. Shared primitives (EmailSchema, MonthSchema, …)
 * live in primitives.ts; cross-tool references are explicit imports between these files.
 */
import { z } from 'zod';
export const UslYearSchema = z.object({ year: z.number().int().min(2020).max(2100) });
const UslStreamMetaSchema = z.record(z.object({ currency: z.string().trim().max(8).optional(), fxConvert: z.boolean().optional() }));
export const UslSaveManualSchema = z.object({
    year: z.number().int().min(2020).max(2100),
    subscription: z.record(z.array(z.number().finite()).max(12)),
    programmatic: z.record(z.array(z.number().finite()).max(12)),
    subscriptionMeta: UslStreamMetaSchema.optional(),
    programmaticMeta: UslStreamMetaSchema.optional(),
});
export const UslSaveForecastSchema = z.object({
    year: z.number().int().min(2020).max(2100),
    repBd: z.string().trim().min(1).max(120),
    tp: z.enum(['t1', 't2', 't3']),
    basic: z.array(z.number().finite()).max(12),
    stretched: z.array(z.number().finite()).max(12),
});
//# sourceMappingURL=usl.js.map